
import styles from '../assets/styles/Introduce.module.css';
import useLanguage from '../hooks/useLanguage';
import { translations } from '../locales/lang';
const IntroduceSection = () => {
    const { language } = useLanguage();
    return (
        <section className={styles.intro} id='introduce'>
            <div className={styles.introText}>
                <div className={styles.containerTitle} data-aos={'zoom-in'}>
                    <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: translations[language].introduce.titleIntroduce }}></h2>
                    <p className={styles.subtitle} dangerouslySetInnerHTML={{ __html: translations[language].introduce.detailIntroduce.first }}></p>
                    <p className={styles.subtitle} dangerouslySetInnerHTML={{ __html: translations[language].introduce.detailIntroduce.second }}></p>
                </div>
            </div>

            <div className={styles.containerPlatform} >
                <div
                    className={`${styles.platform}`}
                    data-aos={'zoom-in'}
                >
                    <img src={translations[language].introduce.platformImage} alt='platform' />
                </div>
            </div>
            <div className={styles.containerIntroduce} data-aos={'zoom-in'}>
                <img src='/images/introduce/bgr-gioi-thieu-tong-quan.svg' alt='bgr-gioi-thieu-tong-quan' className={styles.bgrIntroduce} />
                <div className={styles.containerIntroduceVideo}>
                    <div className={styles.titleIntroduce}>
                        {translations[language].introduce.platformIntroduce}
                    </div>
                    <div className={styles.containerVideo}>
                        <iframe
                            src="https://www.youtube.com/embed/IE3QLK4v6VY?si=1z_RXmgt6F86s5Md&amp;start=6"
                            title="LCMS iSchool - Giới thiệu tổng quan"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </section >
    );
}
export default IntroduceSection;